import { restHelper } from '../helpers/rest.helper';

const AdvancedSearch = async (payload) => {
    let response = await restHelper.post('api/Startup/ActivityAdvancedSearch', payload);
    return response;
}

export default {
    AdvancedSearch
}